// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteAdvanceResponseDados = boolean;

export type Payroll_DeleteAdvanceResponse = ApiResponse<Payroll_DeleteAdvanceResponseDados>;

registerResponseContract('Payroll_DeleteAdvanceResponse', {})
